import { render, staticRenderFns } from "./KvmDomainCheck.vue?vue&type=template&id=fd45462a&scoped=true&"
import script from "./KvmDomainCheck.vue?vue&type=script&lang=js&"
export * from "./KvmDomainCheck.vue?vue&type=script&lang=js&"
import style0 from "./KvmDomainCheck.vue?vue&type=style&index=0&id=fd45462a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd45462a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fd45462a')) {
      api.createRecord('fd45462a', component.options)
    } else {
      api.reload('fd45462a', component.options)
    }
    module.hot.accept("./KvmDomainCheck.vue?vue&type=template&id=fd45462a&scoped=true&", function () {
      api.rerender('fd45462a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/services/hosting/kvm/KvmDomainCheck.vue"
export default component.exports